import { VerticalAlignBottom } from "@mui/icons-material";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import useDesktopLayout from "../../hooks/useDesktopLayout";
import { DesktopDrawerCollapseIcon } from "./DesktopDrawerCollapseIcon";

/** "Collapse/expand sidebar" button pinned at the bottom of the desktop sidebar. */
export function DesktopDrawerCollapseButton() {
    const { t } = useTranslation("app");
    const { isSidebarCollapsed, setIsSidebarCollapsed } = useDesktopLayout();
    const label = isSidebarCollapsed ? t("sidebar.expand") : t("sidebar.collapse");
    const icon = isSidebarCollapsed ? <DesktopDrawerCollapseIcon /> : <VerticalAlignBottom sx={{ transform: "rotate(90deg)" }} />;

    return (
        <ListItem
            dense
            disablePadding
            sx={{
                flexGrow: 0,
                flexShrink: 0,
                borderTop: 1,
                borderColor: "divider",
            }}
        >
            <ListItemButton onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)} aria-label={label}>
                <ListItemIcon>
                    <Tooltip
                        key={isSidebarCollapsed ? "collapsed" : "expanded"}
                        title={label}
                        placement="right"
                        disableHoverListener={isSidebarCollapsed === false}
                    >
                        {icon}
                    </Tooltip>
                </ListItemIcon>
                <ListItemText
                    primary={label}
                    slotProps={{ primary: { variant: "caption", color: "text.primary", sx: { cursor: "pointer" } } }}
                />
            </ListItemButton>
        </ListItem>
    );
}
